<div class="backoffice-companies-container">
  <div class="filter-section">
    <mat-form-field>
      <mat-label>Filtrar</mat-label>
      <input matInput (keyup)="applyFilter($event)" #input />
    </mat-form-field>
  </div>
  <table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>id</th>
      <td mat-cell *matCellDef="let element">{{ element.id }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>phone</th>
      <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="admin">
      <th mat-header-cell *matHeaderCellDef>admin</th>
      <td mat-cell *matCellDef="let element">{{ element.admin }}</td>
    </ng-container>
    <ng-container matColumnDef="company_group_id">
      <th mat-header-cell *matHeaderCellDef>company_group_id</th>
      <td mat-cell *matCellDef="let element">{{ element.company_group_id }}</td>
    </ng-container>
    <ng-container matColumnDef="company_id">
      <th mat-header-cell *matHeaderCellDef>company_id</th>
      <td mat-cell *matCellDef="let element">{{ element.company_id }}</td>
    </ng-container>
    <ng-container matColumnDef="coworker_id">
      <th mat-header-cell *matHeaderCellDef>coworker_id</th>
      <td mat-cell *matCellDef="let element">{{ element.coworker_id }}</td>
    </ng-container>
    <ng-container matColumnDef="coworking_group_id">
      <th mat-header-cell *matHeaderCellDef>coworking_group_id</th>
      <td mat-cell *matCellDef="let element">
        {{ element.coworking_group_id }}
      </td>
    </ng-container>
    <ng-container matColumnDef="coworking_id">
      <th mat-header-cell *matHeaderCellDef>coworking_id</th>
      <td mat-cell *matCellDef="let element">{{ element.coworking_id }}</td>
    </ng-container>
    <ng-container matColumnDef="created_at">
      <th mat-header-cell *matHeaderCellDef>created_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.created_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef>updated_at</th>
      <td mat-cell *matCellDef="let element">
        {{ dateFormatedLong(element.updated_at) }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let element">
        <div class="actions">
          <div (click)="editUser(element)">
            <img [src]="getEditIcon" alt="" />
          </div>
          <div (click)="deleteUser(element)">
            <img [src]="getDeleteIcon" alt="" />
          </div>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="20"></mat-paginator>
</div>
